// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_pEB","comment":"styles_comment__1LJ0z"};